import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const benefits = ['Saber exactamente qué darle de comer a tu perro', 'Preparar comidas naturales fáciles en casa', 'Mejorar su salud, digestión y energía', 'Evitar errores y sentirte segura con lo que le das', 'Empezar hoy mismo con un paso a paso claro'];
export function TransformationSection() {
  return <section className="py-20 px-4 bg-cream" data-id="element-282">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="order-2 lg:order-1 relative" data-id="element-284">
          {/* Image removed */}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="order-1 lg:order-2" data-id="element-285">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-4 leading-tight" data-id="element-286">
            Por eso creamos <br data-id="element-287" />
            <span className="text-primary" data-id="element-288">Nutrición Canina Fácil</span>
          </h2>

          <p className="text-lg md:text-xl text-gray-600 mb-8 font-medium" data-id="element-289">
            Un ebook práctico y paso a paso pensado para que puedas alimentar a
            tu perro de forma natural, sin errores ni confusión.
          </p>

          <div className="space-y-5" data-id="element-290">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center" data-id="element-291">
                <CheckCircle2Icon className="w-6 h-6 text-primary flex-shrink-0 mr-4" data-id="element-292" />
                <span className="text-lg text-gray-800" data-id="element-293">{benefit}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}